/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createSplitUnit } from '../../factoriesAny.js';
export var splitUnitDependencies = {
  typedDependencies: typedDependencies,
  createSplitUnit: createSplitUnit
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSplitUnit.generated.js
// module id = 1657
// module chunks = 0